<template>
  <div class="newmessage-wrap preview" :class="type" v-if="preview_drawer && !minimize">
    <div class="list-create">
      <div class="newmessage-title">
        プレビュー
        <div class="flex-space"></div>
        <el-tooltip :content="theme == 'light' ? 'ダークモード画面のプレビュー' : 'ライトモード画面のプレビュー'" placement="top">
          <div class="newmessage-button" @click="changeTheme()">
            <font-awesome-icon :icon="['fas', 'moon']" v-if="theme == 'light'" />
            <font-awesome-icon :icon="['fas', 'brightness']" v-else />
          </div>
        </el-tooltip>
        <div class="newmessage-button" @click="closePreview()">
          <font-awesome-icon :icon="['fal', 'times']" />
        </div>
      </div>
    </div>

    <div class="newmessage-box">
      <div class="flex-row" style="gap:3px; align-items: flex-start;">
        <div><font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-top: 3px;" /></div>
        <div>端末やOSによっては実際に表示される画面と異なる場合があります。</div>
      </div>
    </div>
    <div class="flex-row" style="gap:3px; align-items: flex-start; justify-content: flex-end;" :style="{ color: replacement_message.length > 1000 ? '#f56c6c' : '' }">
      <div v-if="replacement_message.length > 1000"><font-awesome-icon :icon="['far', 'exclamation-triangle']"/></div>
      <div>パーソナライズ項目を含めた文字数&nbsp;&nbsp;{{ replacement_message.length }}/1000</div>
    </div>
    <div class="message-preview-outer scrollbar-b" :class="theme" v-if="recipient[preview_index] && replacement_message.length > 1">
      <div class="flex-space"></div>
      <div class="preview-time">{{ time }}</div>
      <div class="preview-message-box">
        <div class="preview-icon">
          <el-image :src="s3BaseUrl + '/profile_picture/' + ig_selected.account_name + '.jpg'" class="ig-selected-profile">
            <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
          </el-image>
        </div>
        <div class="preview-message" :class="theme">
          <pre style="margin:0;">{{ replacement_message }}</pre>
        </div>
      </div>
    </div>
    <div class="message-preview-outer norecipient" v-else-if="replacement_message.length > 1">
      <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 3px;" />
      送信先が選択されていません
    </div>
    <div class="message-preview-outer norecipient" v-else>
      <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 3px;" />
      メッセージが入力されていません
    </div>
  </div>
</template>

<script>
export default {
  name: "messagePreview",
  components: {},
  props: ["preview_drawer", "message", "recipient", "preview_index", "minimize", "type"],
  data() {
    return {
      theme: "light",
      preview_recipient: {},
      replacement_message: "",
      time: "",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    ig_selected() {
      return this.$store.state.ig_selected;
    },
  },
  methods: {
    minimizeWindow() {
      this.minimize = !this.minimize;
    },
    closePreview() {
      this.$emit("update:preview_drawer", false);
    },
    changePreviewRecipient() {
      this.preview_recipient = this.recipient[this.preview_index];
    },
    changeTheme() {
      if (this.theme == "light") {
        this.theme = "dark";
      } else {
        this.theme = "light";
      }
    },
    changeMessage() {
      if (this.message) {
        var replacement_message = this.message;
        if (replacement_message.match(/\{\{DM用宛名\}\}/)) {
          if (this.preview_recipient.personalized_name) var name = this.preview_recipient.personalized_name;
          else name = this.preview_recipient.account_name;
        }
        if (replacement_message.match(/\{\{報酬:フォロワー数×([0-9-_.]+)円\}\}/)) {
          var unit_price = replacement_message.match(/\{\{報酬:フォロワー数×([0-9-_.]+)円\}\}/)[1]; //フォロワー単価を抽出
          var price = Math.round((this.preview_recipient.followers_count / 100) * unit_price) * 100; //フォロワー数×フォロワー単価を計算し、100円単位に丸める
          var price_format = new Intl.NumberFormat("ja-JP").format(price); //金額をカンマ区切りにする
        }
        if (replacement_message.match(/\{\{DM用報酬金額\}\}/)) {
          var personalized_price = new Intl.NumberFormat("ja-JP").format(this.preview_recipient.personalized_price); //金額をカンマ区切りにする
        }
        replacement_message = replacement_message.replace(/\{\{DM用宛名\}\}/g, name);
        replacement_message = replacement_message.replace(/\{\{名前\}\}/g, this.preview_recipient.name);
        replacement_message = replacement_message.replace(/\{\{ユーザー名\}\}/g, this.preview_recipient.account_name);
        replacement_message = replacement_message.replace(/\{\{DM用報酬金額\}\}/g, personalized_price);
        replacement_message = replacement_message.replace(/\{\{報酬:フォロワー数×([0-9-_.]+)円\}\}/, price_format);
        this.replacement_message = replacement_message;

        //時間を更新
        var now = new Date();
        var Hour = now
          .getHours()
          .toString()
          .padStart(2, "0");
        var Min = now
          .getMinutes()
          .toString()
          .padStart(2, "0");
        this.time = Hour + ":" + Min;
      } else {
        this.replacement_message = "";
      }
    },
  },
  filters: {},
  watch: {
    message() {
      this.changePreviewRecipient();
      this.changeMessage();
    },
    recipient() {
      this.changePreviewRecipient();
      this.changeMessage();
    },
    preview_index() {
      this.changePreviewRecipient();
      this.changeMessage();
    },
    preview_drawer() {
      if (this.preview_drawer) {
        this.changePreviewRecipient();
        this.changeMessage();
      }
    },
  },
};
</script>
